<template>
    <div class="discounts">
        <b-container>
            <h1 v-t="'discounts.title'"></h1>

            <b-col cols="12" lg="9" class="mx-auto mt-4">
                <i18n path="discounts.description" tag="h2">
                    <router-link to="/pacotes/base">Base</router-link>
                    <router-link to="/pacotes/plus">Plus</router-link>
                    <router-link to="/pacotes/premium">Premium</router-link>
                </i18n>
            </b-col>

            <b-row class="discounts-list">
                <b-col v-for="item in discounts" :key="item.category" class="discounts-list__item mb-4">
                    <i :class="`icon-${item.icon}`"></i>
                    <h3 v-t="`discounts.items.${item.key}`"></h3>
                </b-col>
            </b-row>

            <router-link :to="{ path: '/pacotes/base', hash: '#incentivos'}" class="btn btn-outline-primary">{{ $t('showMore') }}</router-link>

        </b-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                discounts: [
                    {
                        icon: "restaurant strong",
                        key: "restaurants"
                    },
                    {
                        icon: "library",
                        key: "counties"
                    },
                    {
                        icon: "map strong",
                        key: "tours"
                    },
                    {
                        icon: "glass",
                        key: "cellars"
                    },
                    {
                        icon: "cool",
                        key: "other"
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';
.discounts {
    background-color: $color-dirty-white;
}
.container {
    padding: 110px 0 ;
}

.discounts-list {
    color: $primary-color;
    margin: 3.75rem 0 1.875rem;


    i {
        font-size: 3.125rem;
        background: #f5f5f5;
        padding: 0.9375rem;
        border-radius: 0.625rem;
    }

    h3 {
        text-transform: uppercase;
        margin: 1.875rem 0 1.25rem;
    }

    .strong {
        font-weight: 700;
    }

    &__item {
        @media (max-width: $breakpoint-large) {
            flex-basis: 50%;
        }
        @media (max-width: $breakpoint-small) {
            flex-basis: auto;
        }


    }
}

</style>